// TransferredProuuct State

export default {
  receiveList: [],
  receiveInfo: {},
  pendingReceiveCount: 0
}
